import React from "react"
import { Mail, MapPin } from "lucide-react"
import Section from "../common/Section"
import { useContactForm } from "../../hooks/useContactForm"
import { trackContactClick } from "../../analytics"

const Contact = ({ t }) => {
  const {
    formData,
    isSubmitted,
    submitError,
    isLoading,
    handleChange,
    handleSubmit
  } = useContactForm(t.errors)

  return (
    <Section id="contact" className="bg-white text-gray-800">
      <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-10">
        <div>
          <h3 className="text-2xl font-semibold mb-4 text-gray-900">
            {t.title}
          </h3>
          <p className="text-gray-600 mb-6">
            {t.description}
          </p>
          <div className="space-y-4">
            <div className="flex items-center text-gray-700">
              <MapPin size={20} className="mr-3 text-green-500" />
              <span>{t.address}</span>
            </div>
            <div 
              className="flex items-center text-gray-700 cursor-pointer hover:text-green-600"
              onClick={() => {
                trackContactClick('email')
                window.location.href = 'mailto:contact@codegrove.co.kr'
              }}
            >
              <Mail size={20} className="mr-3 text-green-500" />
              <span>contact@codegrove.co.kr</span>
            </div>
          </div>
        </div>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label
              htmlFor="name"
              className="block text-sm font-medium text-gray-700"
            >
              {t.labels.name}
            </label>
            <input
              type="text"
              name="name"
              id="name"
              value={formData.name}
              onChange={handleChange}
              className="mt-1 block w-full px-3 py-2 bg-gray-50 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm text-gray-900"
              required
            />
          </div>
          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-700"
            >
              {t.labels.email}
            </label>
            <input
              type="email"
              name="email"
              id="email"
              value={formData.email}
              onChange={handleChange}
              className="mt-1 block w-full px-3 py-2 bg-gray-50 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm text-gray-900"
              required
            />
          </div>
          <div>
            <label
              htmlFor="message"
              className="block text-sm font-medium text-gray-700"
            >
              {t.labels.message}
            </label>
            <textarea
              name="message"
              id="message"
              rows="4"
              value={formData.message}
              onChange={handleChange}
              className="mt-1 block w-full px-3 py-2 bg-gray-50 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm text-gray-900"
              required
            ></textarea>
          </div>
          <div>
            <button
              type="submit"
              disabled={isLoading}
              className={`w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white transition duration-300 ${
                isLoading 
                  ? "bg-gray-400 cursor-not-allowed" 
                  : "bg-green-500 hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 focus:ring-offset-white"
              }`}
            >
              {isLoading ? t.submit.loading : t.submit.idle}
            </button>
          </div>
          {isSubmitted && (
            <p className="text-green-600 text-center">
              {t.success}
            </p>
          )}
          {submitError && (
            <p className="text-red-600 text-center">{submitError}</p>
          )}
        </form>
      </div>
    </Section>
  )
}

export default Contact
